document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initMarquee();
  initCountUp();
  initGallery();
  initProductForm();
  initBeforeAfter();
  initCountdowns();
  initPackButtons();
  initStickyBuy();
  initScrollButtons();
});

function initScrollButtons() {
  document.querySelectorAll('[data-pkk-scroll-to]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.querySelector(btn.getAttribute('data-pkk-scroll-to'));
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}

function initStickyBuy() {
  var bar = document.querySelector('[data-pkk-sticky-buy]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var triggerSelector = bar.getAttribute('data-pkk-sticky-trigger');
  var trigger = triggerSelector && document.querySelector(triggerSelector);
  if (!trigger) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      bar.classList.toggle('is-visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  observer.observe(trigger);
}

function initPackButtons() {
  document.querySelectorAll('[data-pkk-pack-button]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var form = document.getElementById(btn.getAttribute('form'));
      var input = form && form.querySelector('[name="id"]');
      if (input) input.value = btn.getAttribute('data-variant-id');
    });
  });
}

function initCountdowns() {
  document.querySelectorAll('[data-pkk-countdown]').forEach(function (el) {
    var hours = parseFloat(el.dataset.hours) || 24;
    var totalSeconds = Math.round(hours * 3600);
    var hEl = el.querySelector('[data-cd="h"]');
    var mEl = el.querySelector('[data-cd="m"]');
    var sEl = el.querySelector('[data-cd="s"]');
    var storageKey = 'pkk_cd_' + Math.round(hours * 100);
    var end = parseInt(window.localStorage.getItem(storageKey) || '0', 10);
    var now = Date.now();
    if (!end || end < now) {
      end = now + totalSeconds * 1000;
      try { window.localStorage.setItem(storageKey, String(end)); } catch (e) {}
    }
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var remaining = Math.round((end - Date.now()) / 1000);
      if (remaining <= 0) {
        end = Date.now() + totalSeconds * 1000;
        try { window.localStorage.setItem(storageKey, String(end)); } catch (e) {}
        remaining = totalSeconds;
      }
      var h = Math.floor(remaining / 3600);
      var m = Math.floor((remaining % 3600) / 60);
      var s = remaining % 60;
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    tick();
    setInterval(tick, 1000);
  });
}

function initBeforeAfter() {
  document.querySelectorAll('[data-pkk-before-after]').forEach(function (el) {
    var range = el.querySelector('.pkk-ba-range');
    var beforeWrap = el.querySelector('.pkk-ba-before-wrap');
    var handle = el.querySelector('.pkk-ba-handle');
    var tagBefore = el.querySelector('.pkk-ba-tag--before');
    var tagAfter = el.querySelector('.pkk-ba-tag--after');
    if (!range || !beforeWrap || !handle) return;
    function update() {
      var val = Number(range.value);
      beforeWrap.style.clipPath = 'inset(0 ' + (100 - val) + '% 0 0)';
      handle.style.left = val + '%';
      if (tagBefore) tagBefore.style.opacity = val / 100;
      if (tagAfter) tagAfter.style.opacity = (100 - val) / 100;
    }
    range.addEventListener('input', update);
    range.addEventListener('change', update);
    update();
  });
}

function initReveal() {
  var els = document.querySelectorAll('.pkk-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('pkk-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('pkk-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el, i) {
    el.style.transitionDelay = (i % 6) * 70 + 'ms';
    observer.observe(el);
  });
}

function initMarquee() {
  document.querySelectorAll('.pkk-marquee-track').forEach(function (track) {
    if (track.dataset.duplicated) return;
    var children = Array.from(track.children);
    children.forEach(function (child) {
      track.appendChild(child.cloneNode(true));
    });
    track.dataset.duplicated = 'true';
    var speed = parseFloat(track.dataset.speed || '40');
    track.style.animationDuration = speed + 's';
  });
}

function initCountUp() {
  var els = document.querySelectorAll('.pkk-stat-num[data-target]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        animateCount(entry.target);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function animateCount(el) {
  var target = parseFloat(el.dataset.target) || 0;
  var suffix = el.dataset.suffix || '';
  var duration = 1200;
  var start = null;
  function step(ts) {
    if (start === null) start = ts;
    var progress = Math.min((ts - start) / duration, 1);
    var eased = 1 - Math.pow(1 - progress, 3);
    var value = target * eased;
    el.textContent = (target % 1 === 0 ? Math.round(value) : value.toFixed(1)) + suffix;
    if (progress < 1) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

function initGallery() {
  document.querySelectorAll('[data-pkk-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-pkk-carousel-track]');
    if (!track) return;

    var slides = track.querySelectorAll('.pkk-carousel-slide');
    var prevBtn = gallery.querySelector('[data-pkk-carousel-prev]');
    var nextBtn = gallery.querySelector('[data-pkk-carousel-next]');
    var dots = gallery.querySelectorAll('[data-pkk-carousel-dot]');
    var thumbs = gallery.querySelectorAll('[data-pkk-gallery-thumb]');
    var index = 0;
    var scrollTimeout = null;

    function setActive(i) {
      index = i;
      dots.forEach(function (dot, di) { dot.classList.toggle('is-active', di === index); });
      thumbs.forEach(function (thumb, ti) { thumb.classList.toggle('is-active', ti === index); });
    }

    function goTo(i) {
      var target = ((i % slides.length) + slides.length) % slides.length;
      track.scrollTo({ left: target * track.clientWidth, behavior: 'smooth' });
      setActive(target);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () { goTo(parseInt(dot.getAttribute('data-index'), 10) || 0); });
    });
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () { goTo(parseInt(thumb.getAttribute('data-index'), 10) || 0); });
    });

    track.addEventListener('scroll', function () {
      if (scrollTimeout) clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(function () {
        var current = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.max(0, Math.min(current, slides.length - 1)));
      }, 100);
    });

    setActive(0);
  });
}

function initProductForm() {
  var form = document.querySelector('[data-pkk-product-form]');
  if (!form) return;

  var buttons = Array.prototype.filter.call(
    document.querySelectorAll('[data-pkk-add-button]'),
    function (b) { return b.form === form; }
  );
  var scope = form.closest('.pkk-pdp-purchase') || form;
  var feedbacks = scope.querySelectorAll('[data-pkk-form-feedback]');
  var upsell = form.querySelector('[data-pkk-upsell-checkbox]');

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    buttons.forEach(function (button) {
      button.disabled = true;
      button.dataset.originalText = button.dataset.originalText || button.textContent;
      button.textContent = button.getAttribute('data-loading-text') || 'Añadiendo...';
    });

    var body = {
      id: form.querySelector('[name="id"]').value,
      quantity: 1
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function () {
        if (upsell && upsell.checked && upsell.dataset.variantId) {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: upsell.dataset.variantId, quantity: 1 })
          });
        }
      })
      .then(function () {
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: {}, sections: 'cart-drawer,cart-icon-bubble' })
        });
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && cart.sections && typeof cartDrawer.renderContents === 'function') {
          if (cart.item_count > 0) cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents({ id: body.id, sections: cart.sections });
        } else {
          updateCartBubble(cart.item_count);
        }
        buttons.forEach(function (button) {
          button.textContent = button.getAttribute('data-success-text') || 'Añadido ✓';
        });
        feedbacks.forEach(function (feedback) {
          feedback.hidden = false;
          feedback.classList.add('pkk-visible');
        });
        setTimeout(function () {
          buttons.forEach(function (button) {
            button.disabled = false;
            button.textContent = button.dataset.originalText;
          });
        }, 2200);
      })
      .catch(function () {
        buttons.forEach(function (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText;
        });
        feedbacks.forEach(function (feedback) {
          feedback.hidden = false;
          feedback.textContent = 'No se pudo añadir. Inténtalo de nuevo.';
        });
      });
  });
}

function updateCartBubble(count) {
  var cartIcon = document.getElementById('cart-icon-bubble');
  var bubble = cartIcon ? cartIcon.querySelector('.cart-count-bubble') : document.querySelector('.cart-count-bubble');

  if (count > 0 && !bubble && cartIcon) {
    bubble = document.createElement('div');
    bubble.className = 'cart-count-bubble';
    bubble.innerHTML = '<span aria-hidden="true"></span><span class="visually-hidden">Carrito</span>';
    cartIcon.appendChild(bubble);
  }
  if (!bubble) return;

  var numberEl = bubble.querySelector('span[aria-hidden="true"]');
  if (numberEl) numberEl.textContent = count;
  bubble.style.display = count > 0 ? '' : 'none';
}
